import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted } from 'vue';
import { CookieConsentComponent } from '@shared';
import { cookieManager } from '@shared';
// Initialize cookie manager when app starts
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        onMounted(() => {
            cookieManager.initialize();
        });
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_router_view),
                _createCommentVNode(" Cookie Consent Banner "),
                _createVNode(_unref(CookieConsentComponent))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
